import { lazy } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { ROUTE_PATHS } from 'utils/constants/index'
import LoginIcon from '@mui/icons-material/Login'
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined'
import TableRestaurantOutlinedIcon from '@mui/icons-material/TableRestaurantOutlined'
import PeopleIcon from '@mui/icons-material/People'
import WifiIcon from '@mui/icons-material/Wifi'
import CasinoIcon from '@mui/icons-material/Casino'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import ReceiptIcon from '@mui/icons-material/Receipt'
import Login from 'pages/Auth/Login'

export const routerList = [
  {
    id: uuidv4(),
    sectionName: 'home',
    sectionChilds: [
      {
        key: uuidv4(),
        label: 'dashboard',
        path: ROUTE_PATHS.dashboard,
        component: lazy(() => import('pages/Dashboard')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: DashboardOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'userManagement',
        path: ROUTE_PATHS.users,
        component: lazy(() => import('pages/UserManagement/UserList')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: GroupsOutlinedIcon,
        subMenus: [
          {
            key: uuidv4(),
            label: 'userList',
            path: ROUTE_PATHS.users,
            component: lazy(() => import('pages/UserManagement/UserList')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: PeopleIcon
          },
          {
            key: uuidv4(),
            label: 'onlineUsers',
            path: ROUTE_PATHS.onlineUser,
            component: lazy(() => import('pages/UserManagement/OnlineUsers')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: WifiIcon
          }
        ]
      },
      {
        key: uuidv4(),
        label: 'games',
        path: ROUTE_PATHS.gameList,
        component: lazy(() => import('pages/GamesList')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: CasinoIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'cashGames',
        path: ROUTE_PATHS.cashGames,
        component: lazy(() => import('pages/CashGames')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: TableRestaurantOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'tournaments',
        path: ROUTE_PATHS.tournaments,
        component: lazy(() => import('pages/Tournaments')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: CasinoIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'tournamentTables',
        path: ROUTE_PATHS.tournamentTablesDetails,
        component: lazy(() => import('pages/Tournaments/TournamentTables')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CasinoIcon,
        subMenus: []
      },
      // {
      //   key: uuidv4(),
      //   label: 'tables',
      //   path: ROUTE_PATHS.gameTables,
      //   component: lazy(() => import('pages/TablesList')),
      //   hasAuth: true,
      //   hasSideBarOption: true,
      //   icon: TableRestaurantOutlinedIcon,
      //   subMenus: []
      // },
      {
        key: uuidv4(),
        label: 'Transactions',
        path: ROUTE_PATHS.transactions,
        component: lazy(() => import('pages/TransactionsList')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: PaidOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'reports',
        path: ROUTE_PATHS.reports,
        component: lazy(() => import('pages/Reports')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: TrendingUpIcon,
        subMenus: [
          {
            key: uuidv4(),
            label: 'transactionReports',
            path: ROUTE_PATHS.transactionReports,
            component: lazy(() => import('pages/Reports/TransactionReports')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: ReceiptIcon
          }
        ]
      },
      {
        key: uuidv4(),
        label: 'currency',
        path: ROUTE_PATHS.currencies,
        component: lazy(() => import('pages/Currency')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: CurrencyExchangeIcon,
        subMenus: []
      }
    ]
  },
  {
    id: uuidv4(),
    sectionName: null,
    sectionChilds: [
      {
        key: uuidv4(),
        label: 'login',
        path: ROUTE_PATHS.login,
        component: Login,
        hasAuth: false,
        hasSideBarOption: false,
        icon: LoginIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'settings',
        path: `${ROUTE_PATHS.settings}/*`,
        component: lazy(() => import('pages/Settings')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: LoginIcon,
        subMenus: []
      }
    ]
  },
  {
    id: uuidv4(),
    sectionName: null,
    sectionChilds: [
      {
        key: uuidv4(),
        label: 'settings',
        path: `${ROUTE_PATHS.settings}/*`,
        component: lazy(() => import('pages/Settings')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'change-password',
        path: ROUTE_PATHS.changePassword,
        component: lazy(() => import('pages/Auth/ChangePassword')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'edit-game-setting',
        path: ROUTE_PATHS.editGameSettings,
        component: lazy(() => import('pages/EditGameSetting')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'create-game-table',
        path: ROUTE_PATHS.createGameTable,
        component: lazy(() => import('pages/Tables/CreateTable')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'edit-game-table',
        path: ROUTE_PATHS.editGameTable,
        component: lazy(() => import('pages/Tables/EditTable')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'edit-user',
        path: ROUTE_PATHS.editUser,
        component: lazy(() => import('pages/UserManagement/EditUser')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'user-details',
        path: ROUTE_PATHS.usersDetail,
        component: lazy(() => import('pages/UserManagement/UserDetails')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'view-game-table',
        path: ROUTE_PATHS.viewGameTable,
        component: lazy(() => import('pages/Tables/ViewTable')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      }
    ]
  }
]
